<!-- FEITO  -->
<template>
    <rkm-modal
        large
        ref="Modal"
        title="Cadastro de status"
    >
        <Form
            :data="data"
            :originalStatus="originalStatus"
            :status="status"
            @save="close"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                {{ status ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Components.
import Form from './Form'

// Mixins.
import { object } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalStatus: null,
        status: null,
    }),
    methods: {
        open(status = null) {

            this.resetForm();

            this.originalStatus = status
            this.status = this.clone(status)

            this.$refs.Modal.show()
        },
        resetForm() {

            this.data.form.status = []
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>